export default "../css/348525a733a339193e30f56a3ad87ac9.ttf";